import { render, staticRenderFns } from "./PripadyWizardPredmet.vue?vue&type=template&id=3a32d5d5&"
import script from "./PripadyWizardPredmet.vue?vue&type=script&lang=js&"
export * from "./PripadyWizardPredmet.vue?vue&type=script&lang=js&"
import style0 from "./PripadyWizardPredmet.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VExpandTransition,VForm,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a32d5d5')) {
      api.createRecord('3a32d5d5', component.options)
    } else {
      api.reload('3a32d5d5', component.options)
    }
    module.hot.accept("./PripadyWizardPredmet.vue?vue&type=template&id=3a32d5d5&", function () {
      api.rerender('3a32d5d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pripady_wizard/PripadyWizardPredmet.vue"
export default component.exports